module.exports = __webpack_public_path__ + "img/Community.209e8bff.svg";